export default __webpack_public_path__ + "static/media/sunAmericaLogo.fff320df.svg";